import React from 'react';
import { DateSelection, TimeSelection } from '../';
import { useDateTimePicker } from '../..';
import { Container } from './styled';

export const DateTimeSelection = () => {
  const { hideDate, hideTime } = useDateTimePicker();

  return (
    <Container>
      {!hideDate && <DateSelection />}
      {!hideTime && <TimeSelection />}
    </Container>
  );
};
